<template > 
  <div class="d-ib relative">
    <div  @contextmenu.prevent.stop="rightClick" class="absolute" style="left:-13px;top:-23px">
      <el-button  type="text" :icon="fixed[index] ? 'el-icon-lock' : 'el-icon-unlock'" @click.stop="handleClick"></el-button>
    </div>
    <span>{{value}}</span>
    <i v-if="showSetIcon" class="el-icon-setting c-pointer text-red ml-5" @click.stop="$emit('openHeaderSet')"></i>
  </div>
</template>

<script>
export default {
  props: {
    fixed: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    titleValue: {
      type:String
    },
    showSetIcon:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      value: '',
      table:{},
    }
  },
  mounted() {
    this.value = this.titleValue ? this.titleValue : this.$parent.$parent.$children[this.index].label
    // console.log(this.titleValue,this.index,this.value)
    this.table =  this.$parent.$parent   
  },
  methods: {
    setLayout() {
      if(this.table.showSummary) {
        setTimeout(() => {
          const fixedDom = this.table.$el.getElementsByClassName('el-table__fixed')[0]
          if(!fixedDom.getAttribute('fixed-reseted')) {
            const  h = fixedDom.style.height
            fixedDom.style.height = Number(h.substring(0,h.length - 2)) - 58 + 'px'
            fixedDom.setAttribute('fixed-reseted', true)
          }
        },200)
      }
    },
    handleClick() {
      this.setLayout()
      this.fixed[this.index] = !this.fixed[this.index]
      this.resetSummary()
    },
    rightClick() {
      this.setLayout()
      const flagState = !this.fixed[this.index]
      for(let i in this.fixed) {
        if(i <= this.index) {
          this.fixed[i] = flagState
        }
      }
      this.resetSummary()
    },
    resetSummary() {
      if(this.table.showSummary && this.table.summaryMethod) {
        this.table.summaryMethod()
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Util/TableHeaderFixed.vue